import { useCallback, useEffect, useState } from 'react';
import { getMountings } from '../services/mountings/getMountings';
import { useAuth } from './auth';

export function useMountings() {
    const [mountings, setMountings] = useState([]);
    const [loading, setLoading] = useState([]);
    
    const { id_empresa } = useAuth();

    const loadMountings = useCallback(async () => {
        setLoading(true);

        const response = await getMountings(id_empresa);

        if(response.success) {
            setMountings(response.data);
        }

        setLoading(false);
    }, [id_empresa]);

    useEffect(() => {
        loadMountings();
    }, [loadMountings]);

    return { mountings, loading };
}
